import { Box } from '@chakra-ui/react';
import { clamp } from '@texas/utils/helpers/numberHelpers';
import { useState, useRef } from 'react';

export function useResizeableBox(
  initialWidth: number,
  minWidth: number,
  maxWidth: number,
) {
  const [width, setWidth] = useState(initialWidth);
  const [isDragging, setIsDragging] = useState(false);
  const boxRef = useRef<HTMLDivElement>(null);

  const startResizing = (e: React.MouseEvent) => {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = width;

    const handleMouseMove = (e: MouseEvent) => {
      const clamped = clamp(
        startWidth + (e.clientX - startX),
        minWidth,
        maxWidth,
      );
      setWidth(clamped);
    };
    const handleMouseDown = () => {
      setIsDragging(true);
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('mousedown', handleMouseDown);
      setIsDragging(false);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('mousedown', handleMouseDown);
  };

  const resizableComponent = (
    <Box
      onMouseDown={startResizing}
      pos="absolute"
      right={0}
      top={0}
      width="5px"
      height="100%"
      cursor="ew-resize"
      transition="background-color 200ms ease"
      _active={{
        background: 'whiteAlpha.400',
      }}
      background="whiteAlpha.100" // make visible during dev if needed
      _light={{
        background: 'blackAlpha.100',
        _active: { background: 'blackAlpha.400' },
      }}
    />
  );

  return { boxRef, width, isDragging, resizableComponent };
}
